// import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// import ElementUI from 'element-ui';
import { Message } from 'element-ui';
import ElementForm from 'element-form'
import VueCookie from 'vue-cookie'
import vcolorpicker from 'vcolorpicker'
import 'element-form/lib/element-form.css'
// import 'element-ui/lib/theme-chalk/index.css';
import {RouteUtil} from "./utils/routeUtil";
import {postMessage, postMessageWeb} from "./utils/messageEvent";
import GlobalPlugin from './utils/globalUtil'
import VueClipboard from 'vue-clipboard2'
import componentsRegister from './components'
import {setVuex} from "./utils/upload";
import {setGlobalVuex, setCookie} from "./config/network/injectIntercepter";
import {setUtilsVuex} from "./utils/utils";
import {setCocosUtilsVuex} from "./utils/cocosUtils";
import {setEventBus} from "./store";

setVuex(store)
setGlobalVuex(store)
setUtilsVuex(store)
setCocosUtilsVuex(store)
setCookie(VueCookie)

Vue.use(ElementForm)
    .use(vcolorpicker)
    .use(GlobalPlugin)
    .use(VueClipboard)
    .use(componentsRegister)
    .use(VueCookie)

// 路由初始化
RouteUtil.init(router)

Vue.config.productionTip = false
Vue.prototype.$message = ELEMENT.Message
Vue.prototype.$toCocosMessage = ({type, value, ...data})=> {

  if(value && !value.flag){
    value.flag = 'initial'
  }

  //console.time(`[耗时]向cocos发消息到接收消息==>${type}`)
  if(type === 'AddResource' && !store.state.menusData.lessonSelected){
    Message.error('您未选中菜单')
    return false
  }
  if(type === 'GetLessonConfig'){
    // store.dispatch('setSaving', true)
    store.dispatch('setIsBuilding', true)
    //console.log('游戏共建中测试==>2')
    if(!value.type){
      value = store.state.addEmptyConfig
    }
  }
  switch (type) {
    case 'GetLessonConfig':
      Vue.prototype.$colorLog({1: type})
      break
    case 'SaveConfig': {
      Vue.prototype.$colorLog({3: type})

      const time = new Date().getTime()
      __log__.push({type: 'toCocosSaveConfig',time})

      //console.time(`[耗时]向cocos发SaveConfig==>Complete`)
      //console.time(`[耗时]向cocos发SaveConfig==>Config`)
      break
    }
  }
  return postMessage({type, value, ...data})
}
Vue.prototype.$toWebMessage = ({type, value, callback, ...data})=>{
  return postMessageWeb({type, value, callback, ...data})
}

global.$eventBus = new Vue()

setEventBus(global.$eventBus)

global.__log__ = []
global.__log_func__ = ()=>{
  let c = []
  for(let i = 1,len = __log__.length; i<len; i++){
    c.push(__log__[i].time - __log__[i - 1].time)
  }
  let max = Math.max(...c)
  let maxIndex = c.indexOf(max)
  return {
    __log__,
    sub: c,
    max,
    maxIndex,
    maxIndex1: __log__[maxIndex],
    maxIndex2: __log__[maxIndex + 1],
    start2end: __log__[__log__.length-1].time - __log__[0].time
  }
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')